import { render, staticRenderFns } from "./ExamScoreIndex.vue?vue&type=template&id=418728ae"
import script from "./ExamScoreIndex.vue?vue&type=script&lang=js"
export * from "./ExamScoreIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports